var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowBack = function SvgArrowBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75301 13.2042C7.14168 12.8797 7.19484 12.3022 6.87034 11.9136L3.54009 7.91689L14.4163 7.91689C14.9223 7.91689 15.333 7.50623 15.333 7.00023C15.333 6.49423 14.9223 6.08356 14.4163 6.08356L3.54009 6.08356L6.87034 2.08689C7.19484 1.69731 7.14168 1.11981 6.75301 0.796226C6.36434 0.471725 5.78593 0.523975 5.46234 0.913559L0.879009 6.41356C0.842343 6.45664 0.824925 6.50798 0.797425 6.55564C0.775426 6.59323 0.74976 6.62623 0.733259 6.66748C0.691092 6.77473 0.666343 6.88656 0.666343 7.00023C0.666343 7.11389 0.691092 7.22573 0.733259 7.33298C0.74976 7.37423 0.775426 7.40723 0.797425 7.44481C0.824925 7.49248 0.842343 7.54381 0.879009 7.58689L5.46234 13.0869C5.78593 13.4756 6.36434 13.5287 6.75301 13.2042Z",
    fill: "#18379A"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-back.d192ee7c.svg";
export { ForwardRef as ReactComponent };